import Button from '@/common/components/Button'
import { homologatedStatusLabels } from '@/features/modelIntegrationCodes/constants/homologatedStatusOptions.constant'
import {
  HomologatedModelIntegrationCode,
  HomologatedModelIntegrationCodeTableItem,
  ModelIntegrationCode,
  ModelIntegrationCodeTableItem,
} from '@/features/modelIntegrationCodes/types/modelIntegrationCode.type'
import { ArrowBigRightIcon } from 'lucide-react'
import { Link } from 'react-router-dom'

export class ModelIntegrationCodesTransformer {
  static tableTransformer() {
    return (items: ModelIntegrationCode[] = []): ModelIntegrationCodeTableItem[] =>
      items.map((item) => ({
        id: item.id,
        display_name: item.display_name,
        actions: (
          <Link to={`/model-integration-codes/pending/${item.id}`}>
            <Button
              variant="link-white"
              className="p-0"
              operationKlassToCheckPermission="Admin::EquipmentModels::FindBestIntegrationCodesMatches"
            >
              <ArrowBigRightIcon />
            </Button>
          </Link>
        ),
      }))
  }

  static homologatedTableTransformer() {
    return (items: HomologatedModelIntegrationCode[] = []): HomologatedModelIntegrationCodeTableItem[] =>
      items.map((item) => {
        const statusLabel = homologatedStatusLabels[item.integration_status]
        const isInProgress = item.integration_status === 'link_in_progress'
        const progress = Math.round(Number(item.linking_progress_percentage ?? 0) * 100)

        return {
          id: item.id,
          display_name: item.equipment_model.display_name,
          status: `${statusLabel}
              ${isInProgress ? ` (${progress}%)` : ''}`,
          actions: (
            <Link to={`/equipment-models/${item.equipment_model.id}/integrations`}>
              <Button
                variant="link-white"
                className="p-0"
                operationKlassToCheckPermission="Admin::EquipmentModels::ModelIntegrationCodesFilter"
              >
                <ArrowBigRightIcon />
              </Button>
            </Link>
          ),
        }
      })
  }

  static errorsTransformer() {
    return (errors: Record<string, string[]>) => {
      return Object.entries(errors).map(([key, value]) => {
        if (key === 'value') {
          key = '_base'
        }

        return {
          [key]: value.join(', '),
        }
      })
    }
  }
}
